import { useQuery } from '@tanstack/react-query';
import { getUser } from 'Services/Api/_HumanWritten/UserService';
import { userAccountKeys } from './userAccountKeys';

/**
 * The account pages' user fetch. gcTime 0 keeps the legacy useAsync semantics: every visit to
 * the page starts from a fresh server fetch (spinner), and no cached copy — possibly carrying
 * abandoned edits' side effects — survives navigating away and back.
 */
export const useUserDetail = (id?: string) => {
	return useQuery({
		queryKey: userAccountKeys.detail(id),
		queryFn: () => getUser(id!),
		enabled: !!id,
		staleTime: 0,
		gcTime: 0,
	});
};
